import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationOnixFTPUploadPage } from "~/pages/settings/organisations/organisation/onix/organisation-onix-ftp-upload-page";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/onix-upload/ftp",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.onixUploads") }],
  }),
  component: OrganisationOnixFTPUploadPage,
});
